import React, { useState, useContext, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import { GetUserContext } from '../Context/GetUserContext';
import ProfileDatas from '../Components/PageProfile/ProfileDatas';
import company from '../controller/api/Company'
import user from '../controller/api/User'

const PagePerfil = () => {
    const { loadData, setLoadData, setUserDatas, profileData, setProfileData, axiosConfig, conjIdHome } = useContext(GetUserContext);
    const newCompany = new company();
    const newUser = new user();

    useEffect(() => {
        setLoadData(true)
        newCompany.getCompany(axiosConfig)
            .then(response => {
                setProfileData(response.data)
                setUserDatas(response.data)
                setLoadData(false)
            }).catch(err => {
                console.log(err)
                setLoadData(false)
            })
    }, [])

    return (
        <>
            <Card className='card-container'>
                <Card.Body className='card-content-body'>
                    {conjIdHome == 1 && (<ProfileDatas />)}
                </Card.Body>
            </Card>
            <div></div>
        </>
    )
}

export default PagePerfil